<template>
  <div class="w-full flex items-center justify-center gap-4">
    <div
      v-for="device in lineDevices"
      :key="device.id"
      class="flex flex-col items-center gap-3 cursor-pointer"
      @click="handleSelect(device.original)"
    >
      <div
        class="w-48 h-48 transition-colors rounded-3xl overflow-hidden"
        :class="{ 'ring-2 ring-brand-blue1 bg-key': selectedDevice?.id === device.id }"
      >
        <img
          :src="getImageUrl(device.img)"
          class="w-full h-full bg-neutral-light-default gap-2 object-contain object-center"
        />
      </div>
      <div class="text-black-white text-m-medium">{{ device.name }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useDeviceStore } from '@/stores'
  import { getImageUrl } from '@/utils/assets'
  import { BaseDevice, ConnectionType } from '@rapoo/device-sdk'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  const { devices, deviceList } = storeToRefs(useDeviceStore())
  const props = defineProps<{
    selectedDevice: any
  }>()
  const emit = defineEmits<{
    'update:selectedDevice': [device: BaseDevice]
  }>()

  // 可选设备详情（仅展示有线设备）
  const lineDevices = computed(() => {
    return devices.value.filter((item) => {
      const isWired = item.original.getConnectionType() === ConnectionType.Wired
      const baseDevice = item.original as BaseDevice
      const pid = Array.isArray(baseDevice.manifest.hardware.productId)
        ? baseDevice.manifest.hardware.productId
        : [baseDevice.manifest.hardware.productId]
      const hasReceiver = pid.length > 1 || !!baseDevice.manifest.hardware.pairingProductIds?.length
      return isWired && hasReceiver
    })
  })

  const handleSelect = (original: BaseDevice) => {
    const device = deviceList.value.find((item) => item.id === original.id)
    console.log(original, device)
    emit('update:selectedDevice', device as BaseDevice)
  }
</script>
